(function($){

    $(window).on('load resize', function(){
        
        $('.wp-block-cnm-cnm-menu-mini-sites').each(function(){
            let openBtnTop = $(this).find('.cnm-menu-mini-sites__open').offset().top - 32;
            $(this).find('.cnm-menu-mini-sites__nav').css('top', openBtnTop + "px");
        });

    });

    $(document).on('click', '.cnm-menu-mini-sites__close', function(){
        let nav = $(this).closest('.wp-block-cnm-cnm-menu-mini-sites').find('.cnm-menu-mini-sites__nav');
        $(nav).removeClass('toggled');         
        $('body').removeClass('cnm-popup-toggled');
    }); 

    $(document).on('click', '.cnm-menu-mini-sites__open', function(){
        $('body').addClass('cnm-popup-toggled');
        let nav = $(this).closest('.wp-block-cnm-cnm-menu-mini-sites').find('.cnm-menu-mini-sites__nav');
        $(nav).addClass('toggled');         
    }); 

})(jQuery);